/**
 * Centralized Day Part Helper
 * This helper contains all day part related functionality used across the application
 * to ensure consistency and make it easy to change day part definitions.
 */

/**
 * Get the standard day parts array with internationalized labels
 * @param {Function} $t - Vue i18n translation function
 * @returns {Array} Array of day part objects with value and label
 */
export function getDayParts($t) {
  return [
    { value: "morning", label: $t("ReservationForm.morning") },
    { value: "afternoon", label: $t("ReservationForm.afternoon") },
    { value: "evening", label: $t("ReservationForm.evening") }
  ];
}

/**
 * Validate if a day part value is valid
 * @param {string} dayPart - Day part value to validate
 * @returns {boolean} True if valid, false otherwise
 */
export function isValidDayPart(dayPart) {
  const validDayParts = ["morning", "afternoon", "evening"];
  return validDayParts.includes(dayPart);
}

/**
 * Get day part label by value
 * @param {Function} $t - Vue i18n translation function
 * @param {string} dayPart - Day part value
 * @returns {string} Translated label or empty string if not found
 */
export function getDayPartLabel($t, dayPart) {
  const dayParts = getDayParts($t);
  const found = dayParts.find((dp) => dp.value === dayPart);
  return found ? found.label : "";
}

/**
 * Get the default day part value
 * @returns {string} Default day part value
 */
export function getDefaultDayPart() {
  return "morning";
}

/**
 * Get all available day part values
 * @returns {Array} Array of day part values
 */
export function getDayPartValues() {
  return ["morning", "afternoon", "evening"];
}

/**
 * Get approximate time ranges for day parts
 * @returns {Object} Object with day part keys and time range values
 */
export function getDayPartTimeRanges() {
  return {
    morning: { start: "06:00", end: "12:00" },
    afternoon: { start: "12:00", end: "18:00" },
    evening: { start: "18:00", end: "23:59" }
  };
}
